import { useSpring } from '@react-spring/web';

export const SPRING_SCROLL_CONFIG = { mass: 1, tension: 280, friction: 30 };

/** Physics-based `scrollTo(#id)` for a scrollable container, shared by OnThisPageNav and any in-page jump links. */
export function useSpringScrollTo(scrollContainerRef: React.RefObject<HTMLElement>) {
  const [, api] = useSpring(() => ({
    scrollTop: 0,
    config: SPRING_SCROLL_CONFIG,
    onChange: (result) => {
      const root = scrollContainerRef.current;
      if (root) root.scrollTop = result.value.scrollTop as number;
    },
  }));

  return (id: string) => {
    const root = scrollContainerRef.current;
    const el = document.getElementById(id);
    if (!root || !el) return;
    const target = el.getBoundingClientRect().top - root.getBoundingClientRect().top + root.scrollTop - 8;
    api.start({ from: { scrollTop: root.scrollTop }, to: { scrollTop: target } });
  };
}
